import { computed, inject, Signal } from '@angular/core';

import { Court } from '@shared/interfaces';
import { CourtService } from '@shared/services';

export const getStateCourt = (): Signal<Court> => {
  const courtService = inject(CourtService);
  return computed(() => courtService.court());
};
